<app-dashboard-header></app-dashboard-header>
<div class="main-content" [style.padding-top]="isB2BMode ? '0' : '30px'">
  <router-outlet></router-outlet>
</div>
<app-dashboard-footer></app-dashboard-footer>

